import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const key = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;
if (!url || !key) throw new Error('Supabase configuration is missing.');

export const supabase = createClient(url, key);
export const MEDIA_BUCKET = 'ccm-media';
export const MARKETPLACE_BUCKET = 'marketplace-images';

export const asDocument = ({ id, ...row }) => ({ ...row, id, $id: id });

// Fetch every page, with a stable ID tie-breaker for records sharing a date.
export async function listRecords(table, { type, order = 'createdAt', ascending = false } = {}) {
    const rows = [];
    const pageSize = 500;
    for (let offset = 0; ; offset += pageSize) {
        let query = supabase.from(table).select('*').order(order, { ascending }).order('id');
        if (type) query = query.eq('type', type);
        const { data, error } = await query.range(offset, offset + pageSize - 1);
        if (error) throw error;
        rows.push(...data.map(asDocument));
        if (data.length < pageSize) return rows;
    }
}

export async function createRecord(table, values) {
    const { data, error } = await supabase.from(table).insert({
        id: crypto.randomUUID(), createdAt: new Date().toISOString(), ...values,
    }).select().single();
    if (error) throw error;
    return asDocument(data);
}

export async function updateRecord(table, id, values) {
    const { data, error } = await supabase.from(table).update(values).eq('id', id).select().single();
    if (error) throw error;
    return asDocument(data);
}

export async function deleteRecord(table, id) {
    const { data, error } = await supabase.from(table).delete().eq('id', id).select('id').single();
    if (error) throw error;
    return data;
}

export function mediaUrl(bucket, path) {
    return path ? supabase.storage.from(bucket).getPublicUrl(path).data.publicUrl : null;
}

export function mediaPath(bucket, url) {
    const parsed = new URL(url);
    const expected = new URL(process.env.REACT_APP_SUPABASE_URL);
    const prefix = `/storage/v1/object/public/${bucket}/`;
    if (parsed.origin !== expected.origin || !parsed.pathname.startsWith(prefix)) return null;
    return decodeURIComponent(parsed.pathname.slice(prefix.length));
}

export async function uploadMedia(bucket, file) {
    const path = crypto.randomUUID();
    const { error } = await supabase.storage.from(bucket).upload(path, file, {
        contentType: file.type, cacheControl: '3600', upsert: false,
    });
    if (error) throw error;
    return { id: path, url: mediaUrl(bucket, path) };
}

export async function deleteMedia(bucket, path) {
    if (!path) return;
    const { error } = await supabase.storage.from(bucket).remove([path]);
    if (error) throw error;
}
